const questionType = {
  "Multiple Choice Questions": 1,
  "Single Choice Questions": 2,
  "True False": 3,
  "NUMERICAL": 4
};


export default questionType